// extracted by mini-css-extract-plugin
export default {"popover":"RemoveLanguageButton_popover__Ho5Tx","btn":"RemoveLanguageButton_btn__5LRft","sheet":"RemoveLanguageButton_sheet__JiEYW","actions":"RemoveLanguageButton_actions__X3z-p"};